<template>
  <section>
    <div class="card form-body">
      <div class="card-body">
        <vDataLoader v-if="dataLoading"></vDataLoader>

        <div v-else>
          <iframe
            :src="tcnPdf"
            style="width: 100%; height: calc(100vh - 150px); border: none"
          >
            Oops! an error has occurred.
          </iframe>
        </div>
      </div>

      <div class="card-footer">
        <button
          class="btn btn-danger mr-3"
          @click="goBack()"
          style="float: right"
        >
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { CREATE_COMPANY_INVOICE } from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import vDataLoader from "@/components/frontend/spinner.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    vDataLoader
  },
  computed: {
    ...mapGetters(["currentUser", "getInvoiceAppointments"])
  },
  data() {
    return {
      dataLoading: true,
      tcnPdf: "",
      appointments: "",
      breadCrumbs: [
        {
          id: 1,
          title: "Dashboard",
          route: "client.dashboard"
        },
        {
          id: 2,
          title: "Enrollment List",
          route: "client.storeforward"
        },
        {
          id: 3,
          title: "Release Form",
          route: ""
        }
      ]
    };
  },
  created() {
    this.fetchTcnPdf();
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  },
  methods: {
    goBack() {
      var client_slug = this.$route.params.client_slug;
      this.$router.push({
        name: "report.company.wise.report",
        params: { client_slug: client_slug }
      });
    },
    fetchTcnPdf() {
      var appointments = window.localStorage.getItem(
        "company_invoice_appointment"
      );
      var data_ = {
        appointments: appointments,
        company: this.$route.params.company_id
      };
      this.dataLoading = true;
      this.$store
        .dispatch(CREATE_COMPANY_INVOICE, data_)
        .then(data => {
          const blob = new Blob([data], { type: "application/pdf" });
          const objectUrl = URL.createObjectURL(blob);
          this.tcnPdf = objectUrl;
          this.dataLoading = false;
        })
        .catch(() => {
          this.dataLoading = false;
        });
    }
  }
};
</script>
